/* Galore Discover - Category Filtering + Infinite Scroll + Touch Support */
document.addEventListener('DOMContentLoaded', function () {
  var pills = document.querySelectorAll('.discover-pill');
  var grid = document.getElementById('discover-grid');

  /* ---- Scatter lifestyle tiles randomly ----
     Liquid renders each product's lifestyle tiles consecutively (right after
     its brand tile), and CSS-columns masonry stacks consecutive DOM items in
     the same column — so without this, same-brand images cluster in bands.
     Every lifestyle tile is re-inserted at a random position. */
  function scatterLifestyle(tileList) {
    var tiles = tileList || Array.prototype.slice.call(
      grid.querySelectorAll('.discover-card--lifestyle')
    );
    tiles.forEach(function (tile) { tile.remove(); });
    tiles.forEach(function (tile) {
      var cards = grid.querySelectorAll('.discover-card');
      var insertIndex = Math.floor(Math.random() * (cards.length + 1));
      if (insertIndex >= cards.length) {
        grid.appendChild(tile);
      } else {
        grid.insertBefore(tile, cards[insertIndex]);
      }
    });
  }

  scatterLifestyle();

  /* ---- Category Filtering ---- */
  function getAllCards() {
    return document.querySelectorAll('.discover-card');
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var collection = this.dataset.collection;

      pills.forEach(function (p) { p.classList.remove('active'); });
      this.classList.add('active');

      var delay = 0;
      getAllCards().forEach(function (card) {
        var collections = card.dataset.collections.split(',');
        var show = collection === 'all' || collections.indexOf(collection) !== -1;

        if (show) {
          card.setAttribute('data-hidden', 'false');
          card.style.animation = 'discoverFadeIn 0.4s ease ' + delay + 's both';
          delay += 0.03;
        } else {
          card.setAttribute('data-hidden', 'true');
          card.style.animation = 'none';
        }
      });

      /* The end message counts the whole wall, so it only makes sense on
         the unfiltered view (and only once every page has loaded) */
      if (endMessage) {
        var showEnd = wallComplete && collection === 'all';
        endMessage.hidden = !showEnd;
        endMessage.classList.toggle('discover__end--visible', showEnd);
      }
    });
  });

  /* ---- Infinite Scroll ---- */
  var loader = document.getElementById('discover-loader');
  var moreBtn = document.getElementById('discover-more-btn');
  var endMessage = document.getElementById('discover-end');
  /* No loader rendered = single page = the wall is already complete */
  var wallComplete = !loader;
  var loading = false;
  var observer;

  /* Manual fallback: the button always works even if the observer never fires
     or a fetch fails (it stays visible for retry) */
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      if (!loading) loadMore();
    });
  }

  if (loader && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !loading) {
        loadMore();
      }
    }, { rootMargin: '1000px' });

    observer.observe(loader);
  }

  function loadMore() {
    if (!loader) return;
    var nextUrl = loader.dataset.nextUrl;
    if (!nextUrl) return;

    loading = true;
    loader.classList.add('discover__loader--active');

    fetch(nextUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        /* Extract new cards from the fetched page. No cross-page dedupe:
           pagination is per product, so a product (and all its lifestyle
           tiles, which share its URL) arrives on exactly one page. Same-href
           cards within a page are intentional distinct tiles. */
        var newCards = doc.querySelectorAll('.discover-card');

        newCards.forEach(function (card, i) {
          card.style.animation = 'discoverFadeIn 0.4s ease ' + (i * 0.04) + 's both';
          grid.appendChild(card);
        });

        /* Randomize only the newly appended lifestyle tiles so existing
           content doesn't visibly move under the user */
        var newTiles = [];
        newCards.forEach(function (card) {
          if (card.classList.contains('discover-card--lifestyle')) newTiles.push(card);
        });
        scatterLifestyle(newTiles);

        /* Apply current filter to new cards */
        var activePill = document.querySelector('.discover-pill.active');
        if (activePill && activePill.dataset.collection !== 'all') {
          var collection = activePill.dataset.collection;
          newCards.forEach(function (card) {
            var collections = card.dataset.collections.split(',');
            if (collections.indexOf(collection) === -1) {
              card.setAttribute('data-hidden', 'true');
              card.style.animation = 'none';
            }
          });
        }

        /* Check if there's another page */
        var newLoader = doc.getElementById('discover-loader');
        if (newLoader && newLoader.dataset.nextUrl) {
          loader.dataset.nextUrl = newLoader.dataset.nextUrl;
        } else {
          /* No more pages: remove loader and reveal the finite end state
             (only on the unfiltered view; the pill handler re-toggles it) */
          loader.remove();
          loader = null;
          if (observer) observer.disconnect();
          wallComplete = true;
          var activePillEnd = document.querySelector('.discover-pill.active');
          var isAllView = !activePillEnd || activePillEnd.dataset.collection === 'all';
          if (endMessage && isAllView) {
            endMessage.hidden = false;
            endMessage.classList.add('discover__end--visible');
          }
        }

        loading = false;
        loader && loader.classList.remove('discover__loader--active');

        /* Re-observe so the observer re-reports current intersection state.
           Without this, if the loader never left the rootMargin after new
           cards were appended, no new intersection event fires and the next
           page is never requested. */
        if (loader && observer) {
          observer.unobserve(loader);
          observer.observe(loader);
        }
      })
      .catch(function () {
        loading = false;
        loader && loader.classList.remove('discover__loader--active');
      });
  }

  /* ---- Touch Device Overlay ---- */
  if ('ontouchstart' in window) {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.discover-card__link');
      if (!link) return;
      var card = link.closest('.discover-card') || link;

      if (!card.classList.contains('discover-card--touched')) {
        e.preventDefault();
        document.querySelectorAll('.discover-card--touched').forEach(function (el) {
          el.classList.remove('discover-card--touched');
        });
        card.classList.add('discover-card--touched');
      }
      /* Second tap navigates naturally */
    });
  }
});
